import Qaab from "./Qaab"

function QaabXisaab(){
    return(
        <>
    {/* <!--------------------------xisaabiyayaal ---------------> */}
    <section className="nagu_sabsan">
        <div className="haye">
            <div className="contenar_qaybo">
                <div className="qayb_">
                    <img src="/images/mony_qaab.svg" alt="e_sako" />
                </div>
                {/* Qaab */}
                <Qaab />
            </div>
        </div>
    </section>
        </>
    )
}

export default QaabXisaab